/**
 * Vérifie si une URL est valide
 */
export function isValidUrl(url: string): boolean {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
  } catch {
    return false;
  }
}

/**
 * Extrait le domaine principal d'une URL
 */
export function extractMainDomain(url: string): string {
  try {
    const hostname = new URL(url).hostname;
    // Supprimer le www. s'il est présent
    return hostname.replace(/^www\./, '');
  } catch {
    return url || '';
  }
}

/**
 * Normalise une URL (ajoute https:// si nécessaire)
 */
export function normalizeUrl(url: string): string {
  if (!url) return '';
  
  url = url.trim();
  
  if (!url.match(/^https?:\/\//i)) {
    return `https://${url}`;
  }
  
  return url;
}

/**
 * Crée une version abrégée de l'URL pour l'affichage
 */
export function getShortenedUrl(url: string, maxLength = 30): string {
  try {
    const parsedUrl = new URL(url);
    let shortened = parsedUrl.hostname;
    
    if (parsedUrl.pathname !== '/') {
      shortened += parsedUrl.pathname;
    }
    
    if (shortened.length > maxLength) {
      return shortened.substring(0, maxLength - 3) + '...';
    }
    
    return shortened;
  } catch {
    if (url?.length > maxLength) {
      return url.substring(0, maxLength - 3) + '...';
    }
    return url || '';
  }
}

/**
 * Vérifie si l'URL est probablement scrapable 
 * (basé sur des heuristiques générales - non exhaustif)
 */
export function isProbablyScrapable(url: string): boolean {
  if (!isValidUrl(url)) return false;
  
  try {
    const parsedUrl = new URL(url);
    const hostname = parsedUrl.hostname.toLowerCase();
    
    // Liste de domaines qui sont généralement difficiles à scraper
    const problematicDomains = [
      'facebook.com',
      'twitter.com', 
      'x.com',
      'instagram.com',
      'linkedin.com',
      'youtube.com',
      'tiktok.com',
      'pinterest.com'
    ];
    
    // Vérifier si le domaine est problématique
    for (const domain of problematicDomains) {
      if (hostname === domain || hostname.endsWith(`.${domain}`)) {
        return false;
      }
    }
    
    return true;
  } catch {
    return false;
  }
}

/**
 * Vérifie si l'URL est probablement une page d'accueil
 */
export function isHomepage(url: string): boolean {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.pathname === '/' || parsedUrl.pathname === '';
  } catch {
    return false;
  }
}

/**
 * Obtient l'URL de la favicon d'un site
 */
export function getFaviconUrl(url: string): string {
  try {
    const parsedUrl = new URL(url);
    return `${parsedUrl.protocol}//${parsedUrl.hostname}/favicon.ico`;
  } catch {
    return '';
  }
} 